import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/about/bg2.png")